import {
	Button,
	Card,
	Col,
	Form,
	Input,
	InputNumber,
	Radio,
	Row,
	Select,
	Typography,
} from "antd";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
const { TextArea } = Input;
const { Title } = Typography;
const { Option } = Select;

const AddLoan = () => {
	const dispatch = useDispatch();
	const [form] = Form.useForm();
	const [loader, setLoader] = useState(false);
	const [detailedPurpose, setDetailedPurpose] = useState("");
	const [requestType, setRequestType] = useState("Loan");

	const staffList = useSelector((state) => state.users?.list || []);

	useEffect(() => {
		dispatch(loadAllStaff({ status: true }));
	}, [dispatch]);

	const handleRequestTypeChange = (e) => {
		setRequestType(e.target.value);
	};

	const handleDetailedPurposeChange = (e) => {
		const value = e.target.value;
		if (value.length <= 500) {
			setDetailedPurpose(value);
		}
	};

	const onFinish = async (values) => {
		try {
			setLoader(true);
			// TODO: Replace with actual loan API call
			// const loanData = {
			//   ...values,
			//   requestType: requestType,
			//   detailedPurpose: detailedPurpose,
			//   DataStatus: 1,
			// };
			// const resp = await dispatch(addLoan(loanData));
			
			// Simulate API call for now
			await new Promise((resolve) => setTimeout(resolve, 1000));
			
			toast.success("Loan Application Submitted Successfully!");
			form.resetFields();
			setDetailedPurpose("");
			setRequestType("Loan");
		} catch (error) {
			toast.error("Failed to submit loan application");
		} finally {
			setLoader(false);
		}
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Please fill all required fields");
	};

	return (
		<Fragment>
			<Row className="mb-4" justify="center">
				<Col xs={24} sm={24} md={20} lg={16} xl={14}>
					<Card className="card-custom">
						<Title level={3} className="text-center mb-4">
							Apply Loan (Admin)
						</Title>

						<Form
								form={form}
								style={{ marginBottom: "40px" }}
								name="loan-form"
								labelCol={{
									span: 8,
								}}
								wrapperCol={{
									span: 16,
								}}
								onFinish={onFinish}
								onFinishFailed={onFinishFailed}
								autoComplete="off"
								initialValues={{
									requestType: "Loan",
								}}
							>
								<Form.Item
									style={{ marginBottom: "20px" }}
									label="Select Employee"
									name="employeeId"
									rules={[
										{
											required: true,
											message: "Please select an employee!",
										},
									]}
								>
									<Select
										placeholder="Select employee to apply loan for"
										showSearch
										filterOption={(input, option) =>
											(option?.children ?? "")
												.toLowerCase()
												.includes(input.toLowerCase())
										}
									>
										{staffList?.map((staff) => (
											<Option
												key={staff.id}
												value={staff.id}
											>
												{staff.EmployeeName ||
													`${staff.firstName || ""} ${staff.lastName || ""}`.trim() ||
													staff.UserName}
											</Option>
										))}
									</Select>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "20px" }}
									label="Request Type"
									name="requestType"
									rules={[
										{
											required: true,
											message: "Please select request type!",
										},
									]}
								>
									<Radio.Group
										onChange={handleRequestTypeChange}
										value={requestType}
									>
										<Radio value="Loan">Loan</Radio>
										<Radio value="Advance Payment">
											Advance Payment
										</Radio>
									</Radio.Group>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "20px" }}
									label="Loan Amount (₹)"
									name="loanAmount"
									rules={[
										{
											required: true,
											message: "Please enter loan amount!",
										},
										{
											type: "number",
											min: 1,
											message: "Loan amount must be greater than 0!",
										},
									]}
								>
									<InputNumber
										placeholder="Enter loan amount"
										style={{ width: "100%" }}
										min={0}
										step={100}
										addonBefore="₹"
										formatter={(value) =>
											`${value}`.replace(
												/\B(?=(\d{3})+(?!\d))/g,
												","
											)
										}
										parser={(value) =>
											value.replace(/\$\s?|(,*)/g, "")
										}
									/>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "20px" }}
									label="Returning Months"
									name="returningMonths"
									rules={[
										{
											required: true,
											message: "Please enter months to return!",
										},
										{
											type: "number",
											min: 1,
											message: "Months must be at least 1!",
										},
									]}
								>
									<InputNumber
										placeholder="Enter months to return"
										style={{ width: "100%" }}
										min={1}
										max={120}
									/>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "20px" }}
									label="Purpose Category"
									name="purposeCategory"
									rules={[
										{
											required: true,
											message: "Please select purpose category!",
										},
									]}
								>
									<Select placeholder="Select purpose category">
										<Option value="Medical">Medical</Option>
										<Option value="Education">Education</Option>
										<Option value="Housing">Housing</Option>
										<Option value="Personal">Personal</Option>
										<Option value="Emergency">Emergency</Option>
										<Option value="Other">Other</Option>
									</Select>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "20px" }}
									label="Detailed Purpose"
									name="detailedPurpose"
									rules={[
										{
											required: true,
											message: "Please provide detailed description!",
										},
										{
											max: 500,
											message: "Maximum 500 characters allowed!",
										},
									]}
								>
									<TextArea
										rows={4}
										placeholder="Please provide detailed description of the loan purpose..."
										maxLength={500}
										value={detailedPurpose}
										onChange={handleDetailedPurposeChange}
										showCount
									/>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "20px" }}
									wrapperCol={{
										offset: 8,
										span: 16,
									}}
								>
									<Button
										type="primary"
										size="large"
										htmlType="submit"
										block
										loading={loader}
										disabled={loader}
									>
										Submit Loan Application
									</Button>
								</Form.Item>
							</Form>
					</Card>
				</Col>
			</Row>
		</Fragment>
	);
};

export default AddLoan;

